export const marvinImageSizes = {
  width: 500,
  height: 290,
};

export const enamineToolsUrl = "https://tools.enamine.net";

export const marvinImageStorageKey = "marvin-images";
export const marvinImageStorageItemsLimit = 200;
